import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CustomerRegister from './CustomerRegister';
import DispatcherRegisterWithOTP from './DispatcherRegisterWithOTP';
import MerchantRegister from './MerchantRegister';

type UserRole = 'customer' | 'rider' | 'merchant';

const Register: React.FC = () => {
  const [selectedRole, setSelectedRole] = useState<UserRole>('customer');

  const renderRegistrationForm = () => {
    switch (selectedRole) {
      case 'customer':
        return <CustomerRegister />;
      case 'rider':
        return <DispatcherRegisterWithOTP />;
      case 'merchant':
        return <MerchantRegister />;
      default:
        return <CustomerRegister />;
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-6">
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <img 
              src="/logo.png" 
              alt="Volexx Logistics" 
              className="h-24 sm:h-32 w-auto object-contain"
            />
          </div>
          <h2 className="text-3xl font-bold text-gray-900">
            Join Volexx
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Already have an account?{' '}
            <Link
              to="/login"
              className="font-semibold text-volexx-blue-500 hover:text-volexx-blue-600 transition-colors duration-200"
            >
              Sign in
            </Link>
          </p>
        </div>

        <div className="bg-white p-6 rounded-volexx-lg shadow-volexx border border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Choose your account type
          </h3>
          <div className="space-y-3">
            <label className="flex items-center p-3 rounded-volexx border-2 border-gray-200 hover:border-volexx-blue-500 transition-colors cursor-pointer">
              <input
                type="radio"
                name="role"
                value="customer"
                checked={selectedRole === 'customer'}
                onChange={(e) => setSelectedRole(e.target.value as UserRole)}
                className="h-4 w-4 text-volexx-blue-500 focus:ring-volexx-blue-500 border-gray-300"
              />
              <span className="ml-3 text-sm font-medium text-gray-700">
                Customer - Order deliveries
              </span>
            </label>
            <label className="flex items-center p-3 rounded-volexx border-2 border-gray-200 hover:border-volexx-blue-500 transition-colors cursor-pointer">
              <input
                type="radio"
                name="role"
                value="rider"
                checked={selectedRole === 'rider'}
                onChange={(e) => setSelectedRole(e.target.value as UserRole)}
                className="h-4 w-4 text-volexx-blue-500 focus:ring-volexx-blue-500 border-gray-300"
              />
              <span className="ml-3 text-sm font-medium text-gray-700">
                Dispatcher - Deliver packages
              </span>
            </label>
            <label className="flex items-center p-3 rounded-volexx border-2 border-gray-200 hover:border-volexx-blue-500 transition-colors cursor-pointer">
              <input
                type="radio"
                name="role"
                value="merchant"
                checked={selectedRole === 'merchant'}
                onChange={(e) => setSelectedRole(e.target.value as UserRole)}
                className="h-4 w-4 text-volexx-blue-500 focus:ring-volexx-blue-500 border-gray-300"
              />
              <span className="ml-3 text-sm font-medium text-gray-700">
                Merchant - Manage delivery agents
              </span>
            </label>
          </div>
        </div>

        {renderRegistrationForm()}
      </div>
    </div>
  );
};

export default Register;
